import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      className="bg-black text-white py-12 px-4"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          <motion.div
            className="text-center md:text-left"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-2xl font-serif font-bold mb-4">The Super Tip</h3>
            <p className="font-sans text-sm leading-relaxed">
              Your trusted destination for thrilling sports tipping and casino entertainment with secure transactions.
            </p>
          </motion.div>

          <motion.div
            className="text-center"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h4 className="text-lg font-serif font-semibold mb-4">Legal</h4>
            <div className="font-sans text-sm space-y-2">
              <p><a href="/privacy-policy" className="hover:text-gray-300 transition-colors">Privacy Policy</a></p>
              <p><a href="/terms-of-service" className="hover:text-gray-300 transition-colors">Terms of Service</a></p>
            </div>
          </motion.div>



          <motion.div
            className="col-span-1 md:col-span-2 lg:col-span-1"
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h4 className="text-lg font-serif font-semibold mb-4">Support</h4>
            <p className="text-gray-300 mb-4">
              Have questions or need support? Visit our contact page for more information.
            </p>
            <a
              href="/contact"
              className="inline-block bg-gold hover:bg-gold/80 text-black text-sm font-semibold py-2 px-4 rounded transition-colors"
            >
              Go to Contact Page
            </a>
          </motion.div>
        </div>

        <motion.div
          className="pt-8 border-t border-beige border-opacity-20 text-center"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-sans text-sm">
            &copy; {new Date().getFullYear()} The Super Tip. All rights reserved.
          </p>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
